import axios from './axios';

export const fetchStadiums = async () => {
    const response = await axios.get('/stadiums');
    return response.data;
};

export const fetchMyStadiums = async () => {
    const response = await axios.get('/stadiums/mine');
    return response.data;
};

export const setStadium = async ({ stadiumMode, selectedStadiumID }) => {
    const response = await axios.put('/users/setStadium', { stadiumMode, selectedStadiumID });
    return response.data;
};
